module.exports = __webpack_public_path__ + "static/media/close.089a6e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/incident_layer/close.png
// module id = 363
// module chunks = 0